export type SyncedTimestamp = { timestamp: number; localSyncTime: number }

export function createSyncedTimestamp(timestamp: number): SyncedTimestamp {
  return {
    timestamp,
    localSyncTime: Date.now(),
  }
}
